const globalConfig = {
  rootUrl_sit : 'http://192.168.110.130:8080',
  rootUrl_sit: 'https://beta.khsdb.com', //本地服务器地址
  domainName_sit: 'beta-jiaoyuju.khsdb.com',
  rootUrl_beta: 'https://beta.khsdb.com', //beta服务器地址
  domainName_beta: 'beta-jiaoyuju.khsdb.com',
  rootUrl_uat: 'https://api.khsdb.com', //生产服务器地址
  thirdRootUrl_sit : 'http://192.168.110.130:9090',
  thirdRootUrl_beta : 'https://3rd-test.khsdb.com',
  thirdRootUrl_uat : 'https://3rd.khsdb.com',

  domainName_uat: location.host,
  rootUrl: '', //服务器地址
  type: '', //处于什么平台
  fileUrl: 'https://static.khsdb.com/', //文件服务器地址
  appSecret: 'migoapi*^624123p(*&hashfwr65i',
  appId: '45671323458',
  pageSize: 10,
  domainName : null,
  thirdRootUrl : null,
}


// 测试环境
if (location.host.indexOf('localhost') != -1) {
  globalConfig.rootUrl = globalConfig.rootUrl_sit
  globalConfig.type = 'sit'
  globalConfig.domainName = location.host.indexOf('beta-dev') != -1 ? location.hostname : globalConfig.domainName_sit
  globalConfig.thirdRootUrl = globalConfig.thirdRootUrl_sit
  globalConfig.thirdRootUrl = globalConfig.thirdRootUrl_beta
}
//beta正式环境
else if (location.host.indexOf('beta') != -1) {
  globalConfig.rootUrl = globalConfig.rootUrl_beta
  globalConfig.type = 'beta'
  globalConfig.domainName = location.hostname
  globalConfig.thirdRootUrl = globalConfig.thirdRootUrl_beta
}
//正式环境
else {
  globalConfig.rootUrl = globalConfig.rootUrl_uat
  globalConfig.type = 'uat'
  globalConfig.domainName = globalConfig.domainName_uat
  globalConfig.thirdRootUrl = globalConfig.thirdRootUrl_uat
}

export default globalConfig
